<div #triggerElemRef (click)="onTriggerClick(triggerElemRef)" class="cursor-pointer">
  <ng-content></ng-content>
</div>

<button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" class="hidden-button"></button>

<mat-menu #menu="matMenu" class="inline-date-picker" overlapTrigger="false">
  <app-date-range-picker
    #inlineDatePicker
    class="date-picker"
    [(dates)]="formattedDate"
    [configurationInput]="{
      drops: menuYPosition === 'above' ? 'up' : 'down',
      label: ('field.dueDate' | translate),
      opens: 'center',
      showClearButton: false,
      singleDatePicker: true,
    }"
    (datesChange)="datesChange($event)"
  ></app-date-range-picker>
</mat-menu>
